/**
 * ScamIQBadge — small reusable header pill showing the user's latest Scam IQ + rank.
 * Reads localStorage `ss_latest_result` (written by ScamSmartTest after a completed test).
 * Renders nothing until the user has a saved result.
 *
 * Use `onDark` for navy/dark backgrounds (auto-styled with .ss-iq-badge.on-dark).
 */
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheck } from 'lucide-react';

const ScamIQBadge = ({ onDark = false }) => {
  const [latest, setLatest] = useState(null);

  useEffect(() => {
    const read = () => {
      try {
        const raw = localStorage.getItem('ss_latest_result');
        if (raw) setLatest(JSON.parse(raw));
        else setLatest(null);
      } catch {}
    };
    read();
    // Refresh when storage changes (e.g. after completing a test in another tab).
    window.addEventListener('storage', read);
    return () => window.removeEventListener('storage', read);
  }, []);

  if (!latest || typeof latest.score !== 'number') return null;

  return (
    <Link
      to="/scamsmart/dashboard"
      className={`ss-iq-badge ${onDark ? 'on-dark' : ''}`}
      data-testid="ss-iq-badge"
      title={`Your latest Scam IQ — ${latest.rank}`}
    >
      <span className="ss-iq-badge-icon"><ShieldCheck size={14} /></span>
      <span className="ss-iq-badge-text">
        <span className="ss-iq-badge-score">Scam IQ {latest.score}</span>
        <span className="ss-iq-badge-rank">{latest.rank}</span>
      </span>
    </Link>
  );
};

export default ScamIQBadge;
